import { render, staticRenderFns } from "./opportunity-statuses-widget.vue?vue&type=template&id=60751f7e&"
import script from "./opportunity-statuses-widget.vue?vue&type=script&lang=js&"
export * from "./opportunity-statuses-widget.vue?vue&type=script&lang=js&"
import style0 from "./opportunity-statuses-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports